import { render, staticRenderFns } from "./PerformanceLeftChart.vue?vue&type=template&id=5dc109b6"
import script from "./PerformanceLeftChart.vue?vue&type=script&lang=js"
export * from "./PerformanceLeftChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports